import {ReactElement} from "react";
import "./index.scss";
import {Collapse} from 'antd';

export function CollapseComponent(props:{defaultActiveKey: string, panels:Array<{}> }): ReactElement {
  return (
    <div className="process-document">
      <Collapse
        bordered={false}
        defaultActiveKey={props.defaultActiveKey}
        expandIconPosition={"right"}
      >
      {props.panels}
      </Collapse>
    </div>
  );
}

